document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.ec-how-to-buy__swiper').forEach(swiperEl => {
    const sectionId = swiperEl.dataset.swiperId;
    const totalContent = parseInt(swiperEl.dataset.totalContent, 10);
    const section = swiperEl.closest('.ec-how-to-buy');
    const counter = section.querySelector('.ec-how-to-buy__counter-current');
    const prevBtn = section.querySelector(`[data-swiper-prev="${sectionId}"]`);
    const nextBtn = section.querySelector(`[data-swiper-next="${sectionId}"]`);

    let currentContentIndex = 0;


    const updateNavigation = () => {
      const maxIndex = totalContent - 1;
      
      if (prevBtn) {
        prevBtn.classList.toggle('swiper-button-disabled', currentContentIndex === 0);
      }
      if (nextBtn) {
        nextBtn.classList.toggle('swiper-button-disabled', currentContentIndex >= maxIndex);
      }
    };

    const swiper = new Swiper(swiperEl, {
      slidesPerView: 1,
      spaceBetween: 16,
      loop: false,
      allowTouchMove: true,
      breakpoints: {
        750: {
          slidesPerView: 1.5,
          spaceBetween: 20
        },
        990: {
          slidesPerView: 1.75,
          spaceBetween: 20
        }
      },
      on: {
        slideChange: function() {
          const activeSlide = this.slides[this.activeIndex];
          currentContentIndex = parseInt(activeSlide.dataset.contentIndex, 10);
          
          const radio = document.getElementById(`htb-${sectionId}-${currentContentIndex}`);
          if (radio) radio.checked = true;
          
          if (counter) {
            counter.textContent = currentContentIndex + 1;
          }

          updateNavigation();
        }
      }
    });

    if (prevBtn) {
      prevBtn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (currentContentIndex > 0) {
          swiper.slidePrev();
        }
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (currentContentIndex < totalContent - 1) {
          swiper.slideNext();
        }
      });
    }

    updateNavigation();
  });
});
